<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm
      class="list-component"
      typeForm="list"
      :variableData="variableDataComponent"
    >
      <template v-slot="{}">
        <b-tab id="obs1" title="Tipo de Campo" class="px-1">
          <ValidationObserver ref="obs1">
            <b-card class="card-form shadow">
              <div class="row">
                <div class="col-md-4">
                  <InputSelect
                    id="measure_unit"
                    name="measure_unit"
                    label="Unidad de Medida"
                    :options="measure_unit_options"
                    placeholder="Seleccione una opción"
                    :value.sync="variableDataComponent.config.unitMeasurement"
                  />
                </div>
                <div class="col-md-4">
                  <InputSelect
                    id="fromMaster"
                    validate="required"
                    name="fromMaster"
                    label="Maestro"
                    :options="fromMaster_options"
                    placeholder="Proviene de un maestro"
                    :value.sync="variableDataComponent.config.fromMaster"
                  />
                </div>
                <div class="col-md-4 radio-group">
                  <InputRadio
                    id="isMultiple"
                    validate="required"
                    name="isMultiple"
                    label="Tipo selección"
                    :options="isMultiple_options"
                    :value.sync="variableDataComponent.config.isMultiple"
                  />
                </div>
                <div
                  class="col-md-12"
                  v-if="Object.keys(variableDataComponent.config).length > 0"
                >
                  <div class="row">
                    <div class="col-md-6 pt-1 pl-0 pb-0">
                      <label class="mt-1"
                        >Lista de Opciones: ({{
                          Object.keys(variableDataComponent.config.listOptions)
                            .length
                        }})</label
                      >
                    </div>
                    <div
                      class="col-md-6 pr-0"
                      :class="{
                        'd-none':
                          Object.keys(variableDataComponent.config.listOptions)
                            .length > 0,
                      }"
                    >
                      <CsvLoader
                        ref="fileLoader"
                        v-on:loadSuccess="loadSuccess"
                        class="float-right"
                      ></CsvLoader>
                    </div>
                  </div>
                  <b-list-group
                    :class="{
                      passed:
                        Object.keys(variableDataComponent.config.listOptions)
                          .length > 0,
                      invalid:
                        Object.keys(variableDataComponent.config.listOptions)
                          .length === 0,
                    }"
                  >
                    <b-list-group-item
                      v-for="(list, key) in variableDataComponent.config
                        .listOptions"
                      :key="key"
                      class="p-1"
                    >
                      <b-input-group size="xs">
                        <b-form-input
                          v-model="list.key"
                          class="col-sm-4 col-md-4 col-lg-3"
                          placeholder="Clave"
                        />
                        <b-form-input
                          v-model="list.value"
                          class="col-sm-8 col-md-8 col-lg-9"
                          placeholder="Valor"
                        />
                        <b-input-group-append>
                          <b-button
                            size="xs"
                            variant="info"
                            @click="deleteFromList(key)"
                          >
                            <b-icon icon="trash-fill"></b-icon>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-list-group-item>
                    <b-list-group-item class="p-1">
                      <b-input-group size="xs">
                        <b-form-input
                          v-model="newOption.key"
                          class="col-sm-4 col-md-4 col-lg-3"
                          placeholder="Clave"
                          ref="newOptionKey"
                          v-on:keyup.enter="$refs.newOptionValue.focus()"
                        ></b-form-input>
                        <b-form-input
                          v-model="newOption.value"
                          class="col-sm-8 col-md-8 col-lg-9"
                          placeholder="Valor"
                          ref="newOptionValue"
                          v-on:keyup.enter="handleOption"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="xs"
                            variant="info"
                            :disabled="
                              newOption.value.length === 0 ||
                                newOption.key.length === 0
                            "
                            @click="handleOption"
                          >
                            <b-icon icon="plus"></b-icon>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-list-group-item>
                    <div
                      class="text-danger invalid-feedback d-block px-1"
                      v-if="
                        Object.keys(variableDataComponent.config.listOptions)
                          .length === 0
                      "
                    >
                      Debe especificar una lista de opciones
                    </div>
                  </b-list-group>
                </div>
              </div>
            </b-card>
          </ValidationObserver>
        </b-tab>
      </template>
    </generalForm>
  </div>
</template>

<script>
import Vue from 'vue'
import generalForm from '@/src/components/variables/general-form'
import InputText from '@components/form/InputText'
import InputSelect from '@components/form/InputSelect'
import InputRadio from '@components/form/InputRadio'
import { variablesMethods } from '@state/helpers'
import CsvLoader from 'vue-csv-loader'
// import "vue-csv-loader/dist/csv-loader.css";

export default {
  name: 'listComponent',
  components: {
    generalForm,
    InputText,
    InputSelect,
    InputRadio,
    CsvLoader,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      listOptions: [],
      defaultConfig: {
        unitMeasurement: null,
        fromMaster: 0,
        isMultiple: 0,
        listOptions: [],
      },
      measure_unit_options: [],
      fromMaster_options: [{ value: 0, text: 'No' }, { value: 1, text: 'Si' }],
      isMultiple_options: [
        { value: 0, text: 'Única' },
        { value: 1, text: 'Múltiple' },
      ],
      newOption: { key: '', value: '' },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.fileLoader.$el.children[0][1].setAttribute('accept', '.csv')
    })
    this.getMeasureUnitsData()
    if (Object.keys(this.variableDataComponent.config).length === 0) {
      this.variableDataComponent.config = this.defaultConfig
    }
  },
  methods: {
    ...variablesMethods,

    getMeasureUnitsData() {
      const promise = this.getMeasureUnits()
      let _ = this
      return promise
        .then((data) => {
          data.results.forEach((opt) => {
            _.measure_unit_options.push({ value: opt.id, text: `${opt.name}` })
          })
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las unidades de medida.',
            error
          )
        })
    },

    handleOption() {
      const _newOption = this.newOption
      this.variableDataComponent.config.listOptions.push(_newOption)
      this.newOption = { key: '', value: '' }
      this.$refs.newOptionKey.focus()
    },

    deleteFromList(key) {
      Vue.delete(this.variableDataComponent.config.listOptions, key)
    },

    loadSuccess(result) {
      try {
        // console.log(result)
        let tempList = []
        let errorsList = []
        result.csvBody.forEach((row, index) => {
          const key = String(row[0] || '').replace('\n', '')
          const value = String(row[1] || '').replace('\n', '')
          if (key !== '' && value !== '') {
            tempList.push({ key: key, value: value })
          } else {
            errorsList.push(index)
          }
        })
        if (errorsList.length > 0) {
          this.$generate_noty(
            'warn',
            `Hay ${
              errorsList.length
            } registros que no tienen la estructura adecuada, verifique las filas ${errorsList.join(
              ','
            )} en su archivo`,
            'Carga de archivo CSV',
            8000
          )
        }
        if (tempList.length > 0) {
          this.variableDataComponent.config.listOptions = tempList
          this.$generate_noty(
            'success',
            `Listado cargado exitosamente (${tempList.length} registros)`,
            'Carga de archivo CSV'
          )
        } else {
          this.$generate_noty(
            'warn',
            `El archivo no procesado, verifique. Recuerde que debe ser un archivo CSV (separado por comas) y con 2 columnas.`,
            'Carga de archivo CSV'
          )
        }
      } catch (error) {
        console.error('error:', error)
        this.$generate_noty(
          'warn',
          `Archivo no procesado, verifique. Recuerde que debe ser un archivo CSV (separado por comas) y con 2 columnas.`
        )
        return
      }
    },
  },
}
</script>

<style lang="scss">
.radio-group label {
  font-weight: normal !important;
}
.list-component {
  .invalid {
    border: 1px solid #f1556c !important;
    background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f1556c' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f1556c' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    padding-right: calc(1.5em + 0.9rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }
  .passed {
    border: 1px solid #139e64 !important;
    background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23139e64' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    padding-right: calc(1.5em + 0.9rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }
}
#csv-to-table {
  margin: 10px 1px 3px 1px;

  label.label,
  .field-body .field,
  span.file-label,
  .file-input,
  .file-name {
    display: none;
  }
  .file-icon::after {
    content: 'Subir archivo (.csv)';
    margin-left: 5px;
    color: rgb(73, 73, 73);
  }
  .file-cta {
    border: 1px solid rgb(207, 207, 207);
    padding: 10px;
    border-radius: 5px;
    font-weight: normal;
    &:hover {
      background-color: rgb(240, 240, 240);
      cursor: pointer;
    }
  }
}
</style>
